import React, { useState } from "react";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import styles from "./Modals.module.scss";
import { withTranslation } from "react-i18next";
import crossIcon from "./../../../../../assets/images/cross.svg";
import SearchBar from "accountOwner/pages/Notes/component/Filters/SearchBar";
import { useAllActiveOffices } from "repositories/scheduler-repository";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import constants from "../../../../../constants";
import { encodeId } from "utils";
import Empty from "components/Empty";

let pageSize = 100;
const SelectOfficeModal = ({
  t,
  selectedOwnerId,
  showOfficeSelectModal,
  setShowOfficeSelectModal,
  SelectedDateForLeave,
}) => {
  const [selectedVal, setSelectedVal] = useState(null);
  const [selectedOwner] = useState({ id: 2 });
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();
  const { data } = useAllActiveOffices(
    1,
    pageSize,
    selectedOwnerId,
    searchValue
  );

  const handleApply = () => {
    if (selectedVal?.id) {
      history.push({
        pathname: constants.routes.staff.applyLeaves.replace(
          ":officeId",
          encodeId(selectedVal?.id)
        ),
        state: {
          isFromScheduler: true,
          fromDate: SelectedDateForLeave,
        },
      });
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");
    setSearchValue(value);
  };

  const handleCancel = () => {
    setShowOfficeSelectModal(false);
    setSelectedVal(null);
  };

  return (
    <>
      <Modal
        isOpen={showOfficeSelectModal}
        toggle={handleCancel}
        className={
          "modal-dialog-centered modal-width-660 " +
          styles["change-schedule-modal-dialog"]
        }
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={handleCancel}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" weight="500" color="#111b45">
            <span className="modal-title-25">Select Office</span>
          </Text>
          <SearchBar
            searchValue={searchValue}
            placeholder="Search"
            t={t}
            isModal={true}
            handleSearchTerm={handleSearch}
          />

          <ul className={styles["change-list"] + " " + "mt-4"}>
            {data?.data?.map((item, key) => (
              <li key={key} className="pt-1 pb-1">
                <div className="ch-radio">
                  <label className="mr-5">
                    <input
                      type="radio"
                      onClick={() => setSelectedVal(item)}
                      checked={
                        selectedVal
                          ? item?.id === selectedVal?.id
                          : item?.id === selectedOwner?.id
                      }
                      name="blockTimeslotAllDoctors"
                    />
                    <span>{item?.name}</span>
                  </label>
                </div>
              </li>
            ))}
          </ul>
          {data?.data?.length === 0 && (
            <div className={styles["empty-list"]}>
              <Empty Message={t("notices.emptyMsgOffice")} />
            </div>
          )}

          <button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            title="Proceed"
            onClick={handleApply}
            disabled={!selectedVal?.id}
          >
            Proceed
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link"
            title={t("cancel")}
            onClick={handleCancel}
          >
            {t("cancel")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
};
export default withTranslation()(SelectOfficeModal);
